import React from 'react';

import TagsInput from './tags';

function CustomTagsInput({ value, onChange, disabled }) {
  const handleChange = (val) => {
    onChange(val);
  };

  return (
    <>
      <div className='position-relative'>
        <div className='tags' style={disabled ? { backgroundColor: '#e9ecef' } : {}}>
          <TagsInput disabled={disabled} onChange={handleChange} value={value} />
        </div>
      </div>
      <style jsx>{`
        .tags {
          padding: 2px;
          border: 1px solid #aabfc3;
          border-radius: 5px;
          background-color: #ffffff;
          transition:
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
        }

        .tags-div {
          color: #1f2d3d;
          background-color: #eff2f7;
          border: 1px solid #e0e6ed;
          border-radius: 15px;
          margin: 2px;
          padding: 5px 0px 5px 9px;
          display: inline-block;
        }

        .input_modal_close {
          cursor: pointer;
          text-align: center;
          width: 18px;
          height: 18px;
          background-color: #fff;
          border-radius: 50%;
          margin: 0px 9px 0px 5px;
        }

        .input_modal_input {
          padding: 6px 5px;
          border: none;
          outline: none;
        }

        .input_modal_input:empty::before {
          content: attr(placeholder);
          font-size: 12px;
        }
      `}</style>
    </>
  );
}

export default CustomTagsInput;
